import {useState, useEffect} from "react";
import {Button, Card, Col, Form, Row} from "react-bootstrap";
import {withTranslation} from "react-i18next";
import {URL_API} from "../../../constants/urls";

function AccionTimeDoctor({
                              t,
                              auth,
                              crearHorario,
                              timeIni,
                              setTimeIni,
                              timeEnd,
                              setTimeEnd,
                              setScheduleType,
                              blockedReason,
                              setBlockedreason,
                              submitCreate,
                              error,
                              idDoctor
                          }) {

    const blockedRazonItems = [
        {
            id: 'RETRO',
            name: 'En retroalimentación'
        },
        {
            id: 'COMIDA',
            name: 'En comida'
        },
        {
            id: 'PERSONAL_TIME',
            name: 'En tiempo personal'
        },
        {
            id: 'CAPACITACION',
            name: 'En capacitación'
        },
        {
            id: 'INCAPACIDAD',
            name: 'Incapacidad'
        },
        {
            id: 'DIA_DESCANDO',
            name: 'Día de descanso'
        },
        {
            id: 'ADMIN',
            name: 'Administrativo'
        }
    ]

    const [showReason, setShowReason] = useState(false)
    // const [modalidades, setModalidades] = useState([]);
    // const [selectedModalidades, setSelectedModalidades] = useState('');

    const handleScheduleType = (type, showReason) => {
        if (!showReason) setBlockedreason(null)
        setShowReason(showReason)
        setScheduleType(type)
    }

    // useEffect(() => {
    //     const fetchModalidades = async () => {
    //         if (!idDoctor) return;
    //
    //         try {
    //             const response = await fetch(`${URL_API}/api/doctor/${idDoctor}/modalidades`, {
    //                 headers: {
    //                     'Content-Type': 'application/json',
    //                     "Authorization": `Bearer ${auth.data.access_token}`,
    //                     "Accept": "application/json",
    //                 }
    //             });
    //             const data = await response.json();
    //             setModalidades(data);
    //
    //             if (data.length > 0) {
    //                 setSelectedModalidades(data[0].value);
    //             }
    //         } catch (error) {
    //             console.error('Error fetching modalidades:', error);
    //             setModalidades([]);
    //         }
    //     };
    //
    //     fetchModalidades();
    // }, [idDoctor, auth.data.access_token]);

    return (
        <Card className="shadow-1">
            <Card.Body>
                <Row>
                    <Col>
                        <Form.Group>
                            <Form.Label className="font-weight-bold-600 text-secondary">{t('empieza')}</Form.Label>
                            <Form.Control
                                type="time"
                                className="input-form"
                                value={timeIni}
                                onChange={e => setTimeIni(e.target.value)}
                                placeholder="HH:mm"
                            />
                            <Form.Text className="text-muted">
                                Formato 24hrs HH:mm
                            </Form.Text>
                        </Form.Group>
                        <Form.Group>
                            <Form.Label className="font-weight-bold-600 text-secondary">{t('termina')}</Form.Label>
                            <Form.Control
                                type="time"
                                className="input-form"
                                value={timeEnd}
                                onChange={e => setTimeEnd(e.target.value)}
                                placeholder="HH:mm"
                            />
                            <Form.Text className="text-muted">
                                Formato 24hrs HH:mm
                            </Form.Text>
                        </Form.Group>

                        <div className="mt-2 mb-4">
                            <div>
                                <Form.Check
                                    type="radio"
                                    name="scheduleType"
                                    className="color-blue-dark font-weight-bold-600"
                                    label={t('disponible')}
                                    onChange={e => handleScheduleType('Online', false)}
                                />
                            </div>
                            <div>
                                <Form.Check
                                    type="radio"
                                    name="scheduleType"
                                    className="color-red font-weight-bold-600"
                                    label={t('no_disponible')}
                                    onChange={e => handleScheduleType('Blocked', true)}
                                />
                            </div>
                        </div>
                        {
                            showReason &&
                            <Form.Group>
                                <Form.Label>Razón</Form.Label>
                                <Form.Control
                                    as="select"
                                    className='input-form'
                                    value={blockedReason ? blockedReason : ''}
                                    onChange={e => setBlockedreason(e.target.value)}
                                >
                                    <option value="">Seleccionar</option>
                                    {
                                        blockedRazonItems.map(item => (
                                            <option value={item.id} key={item.id}>{item.name}</option>
                                        ))
                                    }
                                </Form.Control>
                            </Form.Group>
                        }
                        {error &&
                            <div className="text-center text-danger font-size-08rem">Falta información para crear nuevo
                                horario. Por favor revisar y volver a intentar.</div>}
                        <div className="text-center">
                            <Button variant="outline-success" block className="ok-buttom py-1"
                                    type="submit"
                                    onClick={crearHorario}
                                    disabled={submitCreate}
                            >
                                {
                                    submitCreate ?
                                        <div className="spinner-border" role="status"><span
                                            className="sr-only">Loading...</span></div> : 'Crear'
                                }

                            </Button>
                        </div>
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    )

}

export default withTranslation()(AccionTimeDoctor)